<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">แก้ไขรูปภาพเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบรูปภาพเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="grid_flex pa-2">
          <div class="">
            <v-card-title>
              การแสดงผลหน้าเว็บไซต์
            </v-card-title>
          </div>
<!--          <div class="text-right ma-2">-->
<!--            <v-btn x-large class="text-center grad-success-bg white&#45;&#45;text btn_size" @click="image_modal = true">เพิ่มรูปภาพแบรนด์เนอร์</v-btn>-->
<!--          </div>-->
        </div>
        <div class="grid_content">
          <div class="ma-2 padding_img">
            <v-img :src="img_holder"></v-img>
          </div>
          <div>
            <div v-if="loading_list === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else class="ma-2">
              <div v-for="(data, index) in data_list" :key="index">
                <v-card elevation="2" class="pa-2 ma-2">
                  <div class="grid_item">
                    <div class="ml-2 grid_picture">
                      <div class="grid_mx">
                        <v-img class="rounded" height="120" width="120" max-width="120" v-if="data.img === ''" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                        <v-img class="rounded" height="120" width="120" max-width="120" v-if="data.img !== ''" :lazy-src="picture_holder" :src="data.img"></v-img>
                      </div>
                      <div class="ml-3 pt-6">
                        <div style="font-size: 18px">upload {{ data.created_at }}</div>
                        <div v-if="data.link_url !== 'null'" style="font-size: 18px">Link: <a class="hover_link" :href="data.link_url" target="_blank">{{ data.link_url }}</a></div>
                        <div v-else style="font-size: 18px">Link:</div>
                        <div class="mt-2 grey--text" style="font-size: 15px">upload {{ data.user_name }}-{{ data.updated_at }}</div>
                      </div>
                    </div>
                    <div>
                      <div class="text-right">
                        <div class="item_grid">
                          <div>แสดงหน้าเว็บไซต์</div>
                          <v-switch class="mt-0 ml-3" color="#86bc3a" @change="changeStatus(data.id, data.status)" v-model="data.status"></v-switch>
                        </div>
                        <div>
                          <v-btn small height="42" class="grad-warning-bg white--text mb-1 mobile_btn" @click="get_banner_data(data.id)" title="ลบรูปภาพ">
                            <v-icon>mdi-note-edit-outline</v-icon>แก้ไขรูปภาพ
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
      <v-dialog v-model="image_modal" max-width="520">
        <v-card>
          <v-form ref="image" @submit.prevent="">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มรูปภาพแบรนด์เนอร์
              </v-card-title>
              <v-btn icon class="ma-4" @click="image_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                </div>
                <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปภาพแบรนด์เนอร์เว็บไซต์" v-model="banner_image" @change="onFileChange"></v-file-input>
                <div class="grid_full">
                  <div>Link URL</div>
                  <div class="mt-3">
                    <v-text-field color="#86bc3a" label="www.pharmacare-plus.com/xxxx" prepend-inner-icon="mdi-link-variant" hide-details="auto" outlined></v-text-field>
                  </div>
                </div>
                <div class="mt-6">
                  <v-btn x-large v-if="imagePreviewURL == null" class="white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                  <v-btn x-large v-if="imagePreviewURL !== null" class="white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="image_modal_edit" max-width="520">
        <v-card>
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  แก้ไขรูปภาพแบรนด์เนอร์
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal_edit = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-4">
                    <v-img height="300" max-width="300" v-if="edit_list.img == null" :lazy-src="picture_holder" :src="default_img" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-else-if="edit_list.img !== null" :lazy-src="picture_holder" :src="edit_list.img" class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input color="#86bc3a" accept="image/*" label="รูปภาพแบรนด์เนอร์เว็บไซต์" v-model="banner_edit_image" @change="editFileChange"></v-file-input>
                  <div class="grid_full">
                    <div>Link URL</div>
                    <div class="mt-3">
                      <v-text-field color="#86bc3a" label="www.pharmacare-plus.com/xxxx" prepend-inner-icon="mdi-link-variant" v-model="edit_list.link_url" hide-details="auto" outlined></v-text-field>
                    </div>
                  </div>
                  <div class="mt-6">
                    <v-btn x-large v-if="edit_list.img == null" class="white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                    <v-btn x-large v-else-if="edit_list.img !== null" class="white--text grad-success-bg btn_size" @click="edit_upload">อัพโหลด</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import img_holder from "@/assets/banner_main.jpg";
import Swal from "sweetalert2";
import picture_holder from "@/assets/picture.png";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Banner_setting",
  data() {
    return {
      alert_success: false,
      alert_status: false,
      alert_delete: false,
      overlay: false,
      loading_page: false,
      loading_list: false,
      loading_modal: false,
      image_modal: false,
      image_modal_edit: false,
      img_holder: img_holder,
      picture_holder: picture_holder,
      imagePreviewURL: null,
      banner_image: null,
      banner_edit_image: null,
      default_img: null,
      image: null,
      edit_image: null,
      data_list: [],
      edit_list: [],
    }
  },
  methods: {
    onFileChange(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURL = null
      }
    },
    editFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.edit_list.img = null
            this.banner_edit_image = null
          })
        }else {
          if (file) {
            this.edit_list.img = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.edit_list.img = null
            this.banner_edit_image = null
          }
        }
      }else {
        this.edit_list.img = null
        this.banner_edit_image = null
      }
    },
    get_banner_img() {
      this.loading_list = true
      HTTP.post('/manage-website/bannersimage/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_list = false
              this.data_list = res.data.object
            }
          })
    },
    get_banner_data(id) {
      this.edit_list = null
      this.image_modal_edit = true
      this.loading_modal = true
      HTTP.post('/manage-website/bannersimage/getbanner', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          // this.edit_list = res.data.object
          this.edit_list = {
            created_at: res.data.object.created_at,
            id: res.data.object.id,
            img: res.data.object.img,
            link_url: res.data.object.link_url !== 'null' ? res.data.object.link_url : '',
            order: res.data.object.order,
            status: res.data.object.status,
            updated_at: res.data.object.updated_at,
            user_id: res.data.object.user_id,
            user_name: res.data.object.user_name,
          }
          this.default_img = res.data.object.img
        }
      })
    },
    upload_image() {
      this.image_modal = false
      this.alert_success = true
      setTimeout(() => this.alert_success = false,3000)
    },
    edit_upload() {
      if (this.banner_edit_image !== null && this.banner_edit_image !== '') {
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.banner_edit_image.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.banner_edit_image = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('banner_image', this.banner_edit_image, this.banner_edit_image.name)
          formData.append('id', this.edit_list.id)
          formData.append('link_url', this.edit_list.link_url)
          formData.append('order', this.edit_list.order)
          formData.append('status', this.edit_list.status)
          formData.append('user_id', this.$store.state.userDetail.id)
          formData.append('user_name', this.$store.state.userDetail.name)
          this.overlay = true
          this.image_modal_edit = false
          HTTP.post('/manage-website/bannersimage/edit', formData , config)
              .then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  this.get_banner_img()
                  this.alert_success = true
                  setTimeout(() => this.alert_success = false,3000)
                }
              })
        }
      }
      else {
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        let formData = new FormData();
        // formData.append('banner_image', this.banner_edit_image, this.banner_edit_image.name)
        formData.append('id', this.edit_list.id)
        formData.append('link_url', this.edit_list.link_url)
        formData.append('order', this.edit_list.order)
        formData.append('status', this.edit_list.status)
        formData.append('user_id', this.$store.state.userDetail.id)
        formData.append('user_name', this.$store.state.userDetail.name)
        this.overlay = true
        this.image_modal_edit = false
        HTTP.post('/manage-website/bannersimage/edit', formData , config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.get_banner_img()
                this.alert_success = true
                setTimeout(() => this.alert_success = false,3000)
              }
            })
      }
    },
    changeStatus(id, status) {
      HTTP.post('/manage-website/bannersimage/editstatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
  },
  mounted() {
    this.get_banner_img()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.grid_picture {
  display: flex;
}
.grid_content {
  display: grid;
  grid-template-columns: 40% 60%;
}
.grid_item {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.btn_size {
  width: 100%;
}
.item_grid {
  display: flex;
  justify-content: right;
}
.mobile_btn {
  width: 70%;
}
.grid_mx {
  margin: 0;
}
.hover_link {
  color: black;
  cursor: pointer;
}
.hover_link:hover {
  color: #8cc63e;
}
.padding_img {
  padding: 0;
}
@media only screen and (max-width: 1180px) {
  .grid_picture {
    display: grid;
    grid-template-columns: 25% 80%;
  }
  .grid_content {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .padding_img {
    padding: 30px;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_picture {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_item {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .item_grid {
    display: flex;
    justify-content: left;
  }
  .mobile_btn {
    width: 100%;
  }
  .grid_mx {
    margin: auto;
  }
  .padding_img {
    padding: 0;
  }
}
</style>
